interface ProgressRingProps {
  value: number;
  label: string;
  detail?: string;
  tone?: 'cinnabar' | 'jade' | 'ink' | 'wisteria';
  compact?: boolean;
}

export function ProgressRing({ value, label, detail, tone = 'jade', compact = false }: ProgressRingProps) {
  const normalized = Math.min(100, Math.max(0, Number.isFinite(value) ? value : 0));
  const radius = compact ? 25 : 34;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference * (1 - normalized / 100);
  const size = compact ? 72 : 94;
  const center = size / 2;
  return <div className={`progress-ring progress-ring--${tone}${compact ? ' progress-ring--compact' : ''}`} role="img" aria-label={`${label} ${Math.round(normalized)}%`}>
    <svg viewBox={`0 0 ${size} ${size}`} aria-hidden="true">
      <circle className="progress-ring-track" cx={center} cy={center} r={radius} />
      <circle className="progress-ring-value" cx={center} cy={center} r={radius} strokeDasharray={circumference} strokeDashoffset={offset} />
    </svg>
    <div><strong>{Math.round(normalized)}<small>%</small></strong><span>{label}</span>{detail ? <em>{detail}</em> : null}</div>
  </div>;
}
